<template>
    <div>
    
        <CRow class="m-0 justify-content-center align-items-center">
            <div style="width:50%;padding:20px;padding-top:30px" class="text-left">
                <img style="max-width: 40px;" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            </div>
            <div style="width:50%;padding:20px;padding-top:30px" class="text-right">
                <img style="max-width: 40px;" src="../assets/img/country.png" alt="Country Image" />
            </div>
    
            <CCol sm="8" class="text-center mt-3" style="width: 90%;background-size: cover; margin: auto;">
                <!-- Additional content -->
                <div class="p-2">
                    <h5 class="custom-title-app poppin-font mt-2">Who Are You</h5>
                   
                    <CRow class="p-2">
                        <div style="width:48%;margin:5px" :class="{ 'card-grey': true, 'selected': selectedOption === 'worker' }" @click="selectWorker">
                            <div class="p-2 text-center">
                                <img style="max-width: 100px;" src="../assets/img/worker.png" alt="Arrow Left Image" class="p-2" />
                                <h3 class="custom-header-subtitle-sub text-center" :class="{ 'text-white': selectedOption === 'worker' }">Genie Worker</h3>
                <p class="custom-sub-app text-center" :class="{ 'text-white': selectedOption === 'worker' }">Skilled <br />Service Providers</p>
                            </div>
                        </div>
                        <div style="width:48%;margin:5px" :class="{ 'card-grey': true, 'selected': selectedOption === 'aladdin' }" @click="selectAladdin">
                            <div class="p-2 text-center">
                                <img style="max-width: 110px;" src="../assets/img/aladdin.png" alt="Country Image" class="p-2" />
                                <h3 class="custom-header-subtitle-sub text-center" :class="{ 'text-white': selectedOption === 'aladdin' }">Aladdin</h3>
                <p class="custom-sub-app text-center" :class="{ 'text-white': selectedOption === 'aladdin' }">Users Looking<br /> for Services</p>
              
                            </div>
                        </div>
                    </CRow>
                    <div class="mt-2">
                        <div @click="continueClicked" class="button-border-blue text-white">
                            <label class="mt-2">Continue</label>
                        </div>
                        <br />
                    </div>
                </div>
            </CCol>
        </CRow>
        <div class="popup backdrop" v-show="isLanguagePopupVisible">
            <CRow class="m-0 justify-content-center align-items-end">
                <!-- Popup content -->
                <CCol sm="8" class="text-center mt-3" style="width: 90%; background-size: cover; margin: auto;">
                    <div class="bg-white-radius p-2 popup">
                        <h5 class="custom-title-app poppin-font mt-2">Select Language</h5>
                        <p class="custom-sub-title-app poppin-font">Choose your preferred language</p>
    
                        <div class="p-40">
                            <CSelect placeholder="Select Language"></CSelect>
                            <CRow class="m-2">
                                <div style="width:10%"><img style="max-width:100%" src="../assets/img/US.png" /></div>
                                <div style="width:80%">
                                    <h5 class="custom-title-app poppin-font mt-2 text-left ml-2">English (US)</h5>
                                </div>
                                <div style="width:10%"><input type="radio" class="mt-3" v-model="selectedlanguage" value="1"/></div>
                            </CRow>
                            <CRow class="m-2">
    
                                <div style="width:10%"><img style="max-width:100%" src="../assets/img/my.png" /></div>
                                <div style="width:80%">
                                    <h5 class="custom-title-app poppin-font mt-2 text-left ml-2">Malaysia</h5>
                                </div>
                                <div style="width:10%"><input type="radio" v-model="selectedlanguage" value="2" class="mt-3" /></div>
                            </CRow>
    
                            <CRow class="m-2">
                                <div style="width:10%"><img style="max-width:100%" src="../assets/img/indon.png" /></div>
                                <div style="width:80%">
                                    <h5 class="custom-title-app poppin-font mt-2 text-left ml-2">Indonesia</h5>
                                </div>
                                <div style="width:10%"><input type="radio" v-model="selectedlanguage" value="3" class="mt-3" /></div>
                            </CRow>
                        </div>
    
                        <div class="w-80 mx-auto p-40 mt-2">
                            <CButton type="button" class="button-border-blue text-white" block @click="GoToLogin">
                                Select
                            </CButton>
                            <br /> <br /> <br />
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
</template>
  


<style scoped>
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}


</style>

<script>
export default ({
    data() {
        return {
            isLanguagePopupVisible: false,
            selectedOption: null,
            selectedlanguage: ""

        }

    },
    methods: {
        GetInfoUser() {
        return this.$API
            .get(this.$GetListCountry, {
            withCredentials: true,
            })
            .then((response) => {
            if (response.status == 200) {
                this.user = response.data;
            }
            });
        },
        GoToPrevious() {
            this.$router.go(-1);
        },
        GoToLanguage() {
            // Show the popup and backdrop
            this.isLanguagePopupVisible = true;
        },
        GoToWho() {
            // Close the popup and backdrop
            this.isLanguagePopupVisible = false;
        },
        GoToLogin() {
    console.log('Selected language:', this.selectedlanguage); // Check the value of selectedLanguage
    // Construct the route with selectedOption and selectedLanguage parameters
    const route = `/CreateAccount?countryId=${this.$route.query.countryId}&type=${this.selectedOption}&language=${this.selectedlanguage}`;
    // Navigate to the login page with the constructed route
    this.$router.push(route);
    // Close the popup and backdrop after updating the route
    this.isLanguagePopupVisible = false;
},

        GoToWork()
        {
            this.$router.push("/Login?countryId=" + this.$route.path.countryId + "&type=Workers");

        },
        GoToAladdin()
        {
            this.$router.push("/Login?countryId=1&type=Workers");

        },
        selectWorker() {
      this.selectedOption = 'worker';
    },
    selectAladdin() {
      this.selectedOption = 'aladdin';
    },
    continueClicked() {
      if (this.selectedOption) {
        // Pass the selected option to the next step or perform any necessary action
        console.log('Selected option:', this.selectedOption);
        this.isLanguagePopupVisible = true;
       
        //this.$router.push("/Login?countryId=1&type=" + this.selectedOption);
      } else {
        // Handle the case where no option is selected
        console.log('Please select an option before continuing.');
      }
    }
    

    }
})
</script>

<style scoped>
.selected {
  background-color: #323C66; /* Change to your desired blue color */
  color:#fff;
}
</style>
